module.exports = __webpack_public_path__ + "static/media/16UNODC3.c0e07eb6.jpg";